"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var defaultContext = {
    animationState: { currentId: '', animatingId: '', direction: 0 },
    pageSetRef: { current: new Set() },
    setAnimationState: function () { },
    modalHistoryRef: { current: [] },
    setMobileStyle: function () { },
    mobileStyle: 'full'
};
var ModalContext = (0, react_1.createContext)(defaultContext);
exports.default = ModalContext;
